
ADILF.require.config({

    baseUrl: "/src",

    paths: {
        'config': '../require.conf',
        'lib': '../lib',
        'lib/require': '../lib/requirejs/require',
        'jquery': '../lib/jquery/jquery',
        'jquery.cookie': '../lib/jquery-cookie/jquery.cookie',
        'base64': '../lib/base64/base64',
        'hogan': '../lib/hogan/web/builds/2.0.0/hogan-2.0.0.amd',
        'hgn': '../lib/requirejs-hogan-plugin/hgn',
        'text': '../lib/requirejs-text/text',
        'json': '../lib/requirejs-plugins/src/json',
        'almond': '../lib/almond/almond',
        'mout': '../lib/mout/src',
        'node-uuid': '../lib/node-tiny-uuid/index',
        'observer': '../lib/observer/src/observer',
        'promise-polyfill': '../lib/promise-polyfill/promise',
        // Unit testing
        'mocha': '../lib/mocha/mocha',
        'chai': '../lib/chai/chai',
        'sinon': '../lib/sinonjs/sinon',
        'sinon-chai': '../lib/sinon-chai/lib/sinon-chai',
        'adilf/tests': '../tests', // patch for testing page-loader
        // Streamhub SDK things
        'inherits': '../lib/inherits/inherits',
        'event-emitter': '../lib/event-emitter/src/event-emitter',
        'debug': '../lib/debug/debug',
        'streamhub-collection-counter': 'util/streamhub-collection-counter',
        'streamhub-sdk-tests': '../lib/streamhub-sdk/tests',
        'auth': '../lib/streamhub-sdk/tools/auth-stub',
        // Patches for when we completely want to stub a Livefyre component
        'streamhub-sdk/collection/clients/write-client': 'util/livefyre-shims/write-client',
        // Remotely hosted things, defined in runtime config (adilf.js or tests-main.js)
        'livefyre/livefyre-js': 'empty:',
        'livefyre/commentcount': 'empty:',
        'adi-fed/gigya': 'empty:',
        'adi-mt/livefyre-auth': 'empty:',
        'rangle/upload-wall': '../lib/upload-wall/dist/bundle',
    },

    map: {
        "*": {
            'lessc': 'less'
        }
    },

    packages: [{
        name: "adilf",
        location: ".",
        main: "adilf"
    },{
         name: "tests",
         location: "../tests"
    },{
        name: "view",
        location: "../lib/view/src",
        main: "view"
    },{
        name: "livefyre-package-attribute",
        location: "../lib/livefyre-package-attribute/src"
    },{
        name: "livefyre-auth",
        location: "../lib/livefyre-auth/src"
    },{
        name: 'streamhub-ui',
        location: '../lib/streamhub-ui/src'
    },{
        name: "livefyre-bootstrap",
        location: "../lib/livefyre-bootstrap/src"
    },{
        name: "streamhub-share",
        location: "../lib/streamhub-share/src",
        main: 'share-button.js'
    },{
        name: "streamhub-sdk",
        location: "../lib/streamhub-sdk/src"
    },{
        name: "streamhub-sdk/ui",
        location: "../lib/streamhub-sdk/src/ui"
    },{
        name: "streamhub-sdk/modal",
        location: "../lib/streamhub-sdk/src/modal"
    },{
        name: "streamhub-sdk/collection",
        location: '../lib/streamhub-sdk/src/collection'
    },{
        name: "streamhub-sdk/auth",
        location: '../lib/streamhub-sdk/src/auth'
    },{
        name: "streamhub-sdk/content",
        location: '../lib/streamhub-sdk/src/content'
    },{
        name: "streamhub-author-content",
        location: '../lib/streamhub-author-content/src'
    },{
        name: "stream",
        location: "../lib/stream/src"
    },{
        name: "streamhub-hot-collections",
        location: "../lib/streamhub-hot-collections/src"
    },{
        name: "streamhub-feed",
        location: "../lib/streamhub-feed/src"
    },{
        name: "streamhub-feed/styles",
        location: "../lib/streamhub-feed/src/css"
    },{
        name: "streamhub-metrics",
        location: "../lib/streamhub-metrics/src"
    },{
        name: "thread",
        location: "../lib/thread/src"
    },{
        name: "streamhub-input",  
        location: "../lib/streamhub-input/src",
        main: 'javascript/main.js'
    },{
        name: "streamhub-editor",
        location: "../lib/streamhub-editor/src/javascript"
    },{
        name: "streamhub-editor/styles",
        location: "../lib/streamhub-editor/src/styles"
    },{
        name: "streamhub-editor/templates",
        location: "../lib/streamhub-editor/src/templates"
    },{
        name: "livefyre-theme-styler",
        location: "../lib/livefyre-theme-styler/src"
    },{
        name: "streamhub-permalink",
        location: "../lib/streamhub-permalink/src"
    },{
        name: "css",
        location: "../lib/require-css",
        main: "css"
    },{
        name: "less",
        location: "../lib/require-less",
        main: "less"
    }],

    shim: {
        'sinon': { exports: 'sinon' },
        'livefyre/commentcount': { exports: 'LF.CommentCount', deps: ['streamhub-sdk/jquery'] },
        'adi-mt/livefyre-auth': { exports: 'Advance.MT.LiveFyre' },
        'livefyre/livefyre-js': { exports: 'Livefyre' },
        /* For local development & legacy SSF pages; most ADI pages already have these available */
        'adi-fed/loader': { exports: 'AdvAsyncLoader' },
        'adi-fed/gigya': { exports: 'Advance.Gigya' }
    },

    less: {
        paths: ['lib', 'src'],
        relativeUrls: true,
        modifyVars: {
            '@icon-font-path': "\"http://cdn.livefyre.com/libs/livefyre-bootstrap/v1.3.1/fonts/\""
        }
    }

});

ADILF.define("config", function(){});
